<template>
  <div class="relative w-full max-w-xl lg:max-w-2xl flex text-sm">
  <search-filter v-model="form.search" :text="text" :show-filter="false" class="w-full relative border-bottom border-orfBlue-100" @reset="reset"/>
    <div v-if="form.search && form.search.length > 1" class="bg-white overflow-x-auto absolute top-11 max-h-96 w-full z-40 overflow-y-scroll" :class="{'rounded-md rounded-t-none border-t' : loading}">
      <div v-if="loading" class="px-6 py-4 flex-grow">
        <div class="btn-spinner border-orfBlue-100" />
      </div>
      <div v-else class="border-t border-b flex items-center justify-between text-xxs hover:bg-gray-100 font-bold focus-within:bg-gray-100">
        <div class="flex-grow px-6 py-1">
          Name
        </div>
        <div class="w-40 px-6 py-1">
          Abteilung
        </div>
        <div class="hidden lg:flex w-40 px-6 py-1">
          Heute im
        </div>
        <div class="w-40 px-6 py-1 text-right">
          Kalender
        </div>
      </div>
    </div>
  <div v-if="form.search && form.search.length > 1" class="bg-white rounded-md rounded-t-none shadow-md overflow-x-auto absolute max-h-96 w-full z-50 overflow-y-scroll" style="top: 73px">
      <div v-if="!loading" class="relative">
        <div v-for="user in items" :key="user.id" class="border-t flex items-center justify-between hover:bg-gray-100 focus-within:bg-gray-100">
          <div v-if="!loading" class="flex-grow">
            <Link :href="'/users/' + user.id" class="flex items-center px-6 py-4 focus:text-orfBlue-500" >
              <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
              {{ user.name }}
              <HeroIcon v-if="user.deleted_at" name="trash" icon-mini class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </div>
          <div v-if="!loading" class="w-40">
            <Link :href="'/users/ ' + user.id" class="flex items-center px-6 py-4">
              {{ user.department ? user.department.name : '' }}
            </Link>
          </div>
          <div class="hidden lg:flex w-40">
            <Link v-if="user.event_today" class="flex items-center capitalize px-6 py-4" :class="'text-' + user.event_today.type + '-100'" :href="'/users/' + user.id">
              <HeroIcon :name="user.event_today.type" custom-icon class="h-4 w-4 mr-1" :class="'fill-' + user.event_today.type + '-100'"/>
              {{ user.event_today.type}}
            </Link>
          </div>
          <div v-if="!loading" class="w-40 flex justify-end">
            <Link :href="'/users/ ' + user.id" class="flex items-center px-4">
              <loading-button :text="iconText" icon-custom-icon small inverted :icon-name="icon"/>
            </Link>
          </div>
        </div>
        <div v-if="items.length === 0">
          <div class="px-6 py-4 border-t" colspan="4">Kein Mitarbeiter gefunden</div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import {Link} from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import axios from "axios";

export default {
  components: {
    LoadingButton,
    SearchFilter,
    Link,
    HeroIcon,
  },
  props: {
    filters: Object,
    icon: {
      type: String,
      default: "search"
    },
    text: {
      type: String,
      default: "Suche..."
    },
    iconText: {
      type: String,
      default: "Kalender"
    },
    iconHover: {
      type: String,
      default: null
    },
    users: Array,
    href: String,
  },
  data() {
    return {
      items: this.users,
      form: {
        search: this.filters.search,
      },
      loading: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        if (!this.form.search || this.form.search.length > 1) {
          this.loading = true;
          axios.get('/getUsersFromSearch', { params: this.form})
            .then(response => {
              this.items = response.data
              this.loading = false
            });
/*
          this.$inertia.reload({only: ['users'], data: pickBy(this.form), preserveState: true, onSuccess: () => this.loading = false, progress: false})
*/
        }
      }, 250),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }


}
</script>
